import { defineMessages } from 'react-intl';

export const messages: {
	blockLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	cancel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	configurationAriaLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	configureBlock: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	customInstructionsLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	customInstructionsPlaceholder: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	customize: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	fetchError: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	insertDescription: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	insertTitle: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	save: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	saveError: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	insertTitle: {
		id: 'fabric.editor.agentManagedExtension.insert.title.non-final',
		defaultMessage: 'Agent-managed block',
		description:
			'Quick insert / block menu title for inserting a Confluence block whose body is managed by a Rovo agent.',
	},
	insertDescription: {
		id: 'fabric.editor.agentManagedExtension.insert.description.non-final',
		defaultMessage: 'Configure a block to your desired output and let Rovo keep it updated',
		description: 'Quick insert / block menu description for inserting an agent-managed block.',
	},
	customize: {
		id: 'fabric.editor.agentManagedExtension.toolbar.customize.non-final',
		defaultMessage: 'Customize',
		description:
			'Floating toolbar button label that opens the inline configuration for an agent-managed block.',
	},
	configureBlock: {
		id: 'fabric.editor.agentManagedExtension.config.title.non-final',
		defaultMessage: 'Customize Agent-managed block',
		description: 'Heading of the inline configuration panel for an agent-managed block.',
	},
	customInstructionsLabel: {
		id: 'fabric.editor.agentManagedExtension.config.customInstructionsLabel.non-final',
		defaultMessage: 'Custom instructions',
		description:
			'Label for the textarea where the user enters the agent prompt for an agent-managed block.',
	},
	customInstructionsPlaceholder: {
		id: 'fabric.editor.agentManagedExtension.config.customInstructionsPlaceholder.non-final',
		defaultMessage:
			'Tell the agent what this block should contain. For example: "Summarise the latest takeaways from my meetings with Team A and write a short summary that..."',
		description: 'Placeholder text for the agent prompt textarea.',
	},
	save: {
		id: 'fabric.editor.agentManagedExtension.config.save.non-final',
		defaultMessage: 'Save',
		description: 'Save button in the inline configuration panel for an agent-managed block.',
	},
	cancel: {
		id: 'fabric.editor.agentManagedExtension.config.cancel.non-final',
		defaultMessage: 'Cancel',
		description: 'Cancel button in the inline configuration panel for an agent-managed block.',
	},
	blockLabel: {
		id: 'fabric.editor.agentManagedExtension.blockLabel.non-final',
		defaultMessage: 'Agent-managed',
		description: 'Small lozenge label shown on the agent-managed block in the editor.',
	},
	fetchError: {
		id: 'fabric.editor.agentManagedExtension.fetchError.non-final',
		defaultMessage:
			'Unable to load this agent-managed block. It may have been deleted or you may not have permission to view it.',
		description:
			'Error message shown in the block body when the AI-managed object cannot be loaded from the backend.',
	},
	saveError: {
		id: 'fabric.editor.agentManagedExtension.config.saveError.non-final',
		defaultMessage: 'Something went wrong while saving. Please try again.',
		description:
			'Inline error message shown in the configuration popup when saving or updating the AIMO fails.',
	},
	configurationAriaLabel: {
		id: 'fabric.editor.agentManagedExtension.config.ariaLabel.non-final',
		defaultMessage: 'Agent-managed block configuration',
		description:
			'Accessible label for the popup that lets users configure the prompt for an agent-managed block.',
	},
});
